import type { TMessengerErpLayoutMode } from '@xometry/ui';
import type { TSideOverlayContext } from 'stores/SideOverlay/SideOverlayStore';

import { getEffectiveErpMessengerUserPreferenceForReinit } from './getEffectiveErpMessengerUserPreferenceForReinit';
import {
  getErpMessengerLayoutModeForMessengerPayload,
  type ReinitLikePayload,
} from './getErpMessengerLayoutModeForPayload';

export interface WithMessengerReinitLayoutModeArgs<P extends ReinitLikePayload = ReinitLikePayload> {
  userPreference: TMessengerErpLayoutMode;
  isMobile: boolean;
  isEmbedded: boolean;
  payload: P;
  /** When set, `forceClassic` overlay presentation forces classic in the MFE payload (same as host). */
  overlayContext?: TSideOverlayContext;
}

export const withMessengerReinitLayoutMode = <P extends ReinitLikePayload>({
  userPreference,
  isMobile,
  isEmbedded,
  payload,
  overlayContext,
}: WithMessengerReinitLayoutModeArgs<P>): P & { erpMessengerLayoutMode: TMessengerErpLayoutMode } => {
  const effectiveUserPreference =
    overlayContext != null
      ? getEffectiveErpMessengerUserPreferenceForReinit(overlayContext, userPreference)
      : userPreference;

  return {
    ...payload,
    erpMessengerLayoutMode: getErpMessengerLayoutModeForMessengerPayload({
      userPreference: effectiveUserPreference,
      isMobile,
      isEmbedded,
      payload,
    }),
  };
};
